import { type SyntheticEvent, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { type SegmentsListTabs, segmentsListTabs } from '../types.ts';

const getTabFromPath = (pathname: string) => {
  return pathname.split('/').pop() ?? segmentsListTabs.AUDIENCE_SEGMENTS;
};

export const useSegmentListTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(getTabFromPath(location.pathname));

  useEffect(() => {
    const tabFromPath = getTabFromPath(location.pathname);

    if (tabFromPath !== activeTab) {
      setActiveTab(tabFromPath);
    }
  }, [activeTab, location.pathname]);

  const changeTab = useCallback(
    (_: SyntheticEvent<Element, Event>, newTab: SegmentsListTabs) => {
      if (newTab === activeTab || !Object.values(segmentsListTabs).includes(newTab)) {
        return;
      }

      navigate(`/segments/${newTab}`);
    },
    [activeTab, navigate]
  );

  return {
    activeTab,
    changeTab,
  };
};
